// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const SwatchContract = contract({
  name: "Swatch",
  description: "Showing a colour as a small chip — brand-pop strips, palette / accent pickers, theme previews, token galleries, \"pick a colour\" rows. Reach for `token` to bind to a live theme variable; `color` for raw values. A transparency checkerboard sits behind the fill so semi-transparent values read honestly.",
  import: "@gradeui/ui",
  aliases: ["colour swatch","color swatch","colour chip","color chip","palette swatch","token swatch","brand pop","accent swatch","colour tile","color tile","paint chip","react native colour swatch"],
  subcomponents: ["SwatchGroup"],
  composesWith: ["Row (strip of swatches)","Stack","Grid (palette wall)","Field (as a colour-picker trailing slot)","Card (in a theme-preview)","RadioGroup (selectable accent set)","Label"],
  styleDefaults: {"Swatch":"relative inline-block shrink-0 overflow-hidden shadow-elevation-1 size-8 rounded-[var(--radius)]","SwatchGroup":"inline-flex flex-wrap items-center"},
  variantDefaults: {"size":"md","shape":"rounded"},
  props: {
  "color": {
      schema: z.string().optional(),
      design: "content",
      description: "any raw CSS colour (`#1f6feb`, `oklch(...)`, `rgb(...)`, or `var(--x)`). Takes precedence over `token`. Use for one-off or external colours.",
  },
  "token": {
      schema: z.string().optional(),
      design: "content",
      description: "a Grade colour token NAME with no `--` and no `oklch()` wrap; resolved internally to `oklch(var(--<token>))`. THE design-system path — e.g. `token=\"brand-3\"`, `token=\"primary\"`, `token=\"chart-2\"`. Re-voices live when the theme changes.",
  },
  "type": {
      schema: z.enum(["solid", "gradient", "image"]).optional(),
      design: "knob",
      description: "fill kind; default solid (or inferred from `image` / `gradient`). Determines what the chip renders in place.",
  },
  "gradient": {
      schema: z.string().optional(),
      design: "content",
      description: "CSS gradient for `type=\"gradient\"`, e.g. `linear-gradient(135deg,#6366f1,#ec4899)`.",
  },
  "image": {
      schema: z.string().optional(),
      design: "content",
      description: "image URL for `type=\"image\"`; rendered cover-fit behind the chip.",
  },
  "size": {
      schema: z.enum(["2xs", "xs", "sm", "md", "lg", "xl"]).optional(),
      design: "knob",
      description: "t-shirt scale, 16px → 56px; default md (32px). 2xs (16px) suits dense colour lists. Prefer over h-*/w-* utilities.",
  },
  "shape": {
      schema: z.enum(["square", "rounded", "circle"]).optional(),
      design: "knob",
      description: "default rounded (rides `--radius`); circle for dot pickers; square for a hard tile.",
  },
  "selected": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "draws the shared selection ring (`--selected`). For palette / accent pickers.",
  },
  "onSelect": {
      schema: z.unknown().optional(),
      design: "event",
      description: "makes the swatch a pickable <button> (adds aria-pressed, focus ring, hover lift). Omit for a static display chip.",
  },
  "onColorChange": {
      schema: z.unknown().optional(),
      design: "event",
      description: "makes the swatch an editable colour well: hosts a native `<input type=\"color\">` (the OS picker) behind the DS chip and fires with the new `#rrggbb`. Presentation stays the chip, interaction stays native. Use for inspector / control-panel colour fields instead of styling a raw colour input. Takes precedence over `onSelect`.",
  },
  "label": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "caption rendered beneath the chip; also becomes the accessible name + tooltip.",
  },
  "layout": {
      schema: z.enum(["row", "stack"]).optional(),
      design: "knob",
      description: "`row` (default) spaces chips out; `stack` overlaps them into a coin-stack (the theme-picker / \"key colours\" treatment, where each chip's ring reads as the separating edge).",
  },
  "gap": {
      schema: z.enum(["xs", "sm", "md", "lg"]).optional(),
      design: "knob",
      description: "spacing between chips in `row` layout; default sm.",
  },
  },
});
